import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonFab, IonFabButton, IonIcon, IonButtons, IonButton, IonSpinner, IonItem, IonAvatar, IonLabel, IonLoading, IonSegment, IonSegmentButton } from '@ionic/react';
import { useState, useEffect, useRef } from 'react';
import { checkmark, chevronBack, remove } from 'ionicons/icons';
import { useHistory, useParams } from 'react-router';
import { getFile, getFileMetadata, updateFile } from '../firebase/firebaseStorage';
import dateFormat from 'dateformat';
import { getUser } from '../firebase/users';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Permissions from './Permissions';
import { getMetadata } from '@firebase/storage';


const ImagePermissions: React.FC<{}> = (props) => {
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [metadata, setMetadata] = useState<any>();


  const [busy, setBusy] = useState(false);
  const params: any = useParams();

  const path = params.url.replaceAll("-", "/");

  //console.log("ImagePermissions 222", metadata);
  useEffect(() => {
    setBusy(true);
    getFileMetadata(path).then((metadata) => {
      
      if (metadata?.customMetadata?.permissions !== undefined) {
        setMetadata(JSON.parse(metadata?.customMetadata?.permissions));
      }
    })
  }, []);





  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {metadata !== undefined && metadata !== null?<Permissions collection={path} id={""} permissions={metadata} updateDate={null} db={false} goBackAfterSave={true} />:""}
        
      </IonContent>
    </IonPage >
  );
};

export default ImagePermissions;
